import React, { useState, useEffect } from "react";
import { getDayColor } from "../../../utils/calendarColorUtils";
import {
  getDaysInMonth,
  getFirstDayOfMonth,
} from "../../../utils/timeFunction";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { getGreenMonthlyReadingsApi } from "../../../api/api";

const BreathalyzerReadings = ({
  currentMonth,
  setCurrentMonth,
  targetValue,
  user,
}) => {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [dayValues, setDayValues] = useState([]);
  const currentYear = currentDate.getFullYear();
  const month = currentDate.toLocaleString("default", { month: "long" });

  // Fetch API data
  const fetchDayValues = async () => {
    const res = await getGreenMonthlyReadingsApi(user, currentMonth);
    if (res?.error) {
      Toast.fire({
        icon: "error",
        title: "Something went wrong",
      });
    } else {
      setDayValues(res);
    }
  };

  useEffect(() => {
    fetchDayValues();
  }, [currentMonth, user]);

  const handlePrevMonth = () => {
    setCurrentMonth((prev) => prev - 1);
    setCurrentDate(new Date(currentYear, currentMonth - 1, 1));
  };

  const handleNextMonth = () => {
    setCurrentMonth((prev) => prev + 1);
    setCurrentDate(new Date(currentYear, currentMonth + 1, 1));
  };

  const generateCalendarDays = () => {
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();
    const daysInMonth = getDaysInMonth(year, month);
    const firstDayOfMonth = getFirstDayOfMonth(year, month);

    const calendarDays = Array.from({ length: firstDayOfMonth }, (_, i) => (
      <div key={`empty-${i}`} className="day mb-1"></div>
    ));

    return [
      ...calendarDays,
      ...Array.from({ length: daysInMonth }, (_, i) => {
        const day = i + 1;

        const dayColor = getDayColor(dayValues[day - 1], targetValue);

        return (
          <div style={{ backgroundColor: dayColor }} className="day mb-1"></div>
        );
      }),
    ];
  };

  return (
    <div className="p4">
      <div className="flex justify-around items-center mb-4">
        <div onClick={handlePrevMonth} className="font-poppin cursor-pointer">
          <FontAwesomeIcon
            icon={faArrowLeft}
            style={{
              width: "24px",
              height: "24px",
            }}
          />
        </div>
        <h2 className="text-2xl font-bold">
          {month} {currentYear}
        </h2>
        <div onClick={handleNextMonth} className="font-poppin cursor-pointer">
          <FontAwesomeIcon
            icon={faArrowRight}
            style={{
              width: "24px",
              height: "24px",
            }}
          />
        </div>
      </div>
      <div className="flex justify-center flex-col ">
        <div className="grid ">
          {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day) => (
            <div
              key={day}
              className="text-center font-bold place-items-center text-xl font-poppin"
            >
              {day}
            </div>
          ))}
        </div>
        <div className="grid mt-2 place-items-center">
          {generateCalendarDays()}
        </div>
      </div>
    </div>
  );
};

export default BreathalyzerReadings;
